import { ZAKAZKA_DRUH } from '@/modules/servis/zakazka/constants';

export { DMS_MODULE, ZAKAZKA_ND as NAME } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakazkand';

export const ZAKAZKAND_MOZNO_VYDAT = 'MoznoVydat';
export const ZAKAZKAND_NASLEDNICI = 'NahradyNasledovnici';
export const ZAKAZKAND_POHYB = 'NdpohybZakazka';
export const ZAKAZKAND_PREDCHUDCE = 'NahradyPredchudce';
export const ZAKAZKAND_SHODA = 'ShodaNd';
export const ZAKAZKAND_CAMPAIGN = 'Campaign';
export const SPLIT_BILLING = 'SplitBilling';
export const PARTS = 'PARTS';
export const START_INSEX = 0
export const SERVICE_JOB_SPLIT_BILLING='ServiceJobSplitBilling';
export const MAX_SHARE_PERCENTAGE = 100;
export const BULK_UPLOAD = 'Bulk Parts Upload';
export const ROW_SAVED = 'Parts Row Saved';
export const ROW_EDIT_CLICKED = 'Parts Row Edit Clicked';
export const PART_SELECTED = 'TBW Part Selected';
export const SAGA_ITEM_ADJUSTED = 'Saga Item Adjusted';


export const DEPENDENT_TABLES_ALL = <const>[
	ZAKAZKAND_MOZNO_VYDAT,
	ZAKAZKAND_NASLEDNICI,
	ZAKAZKAND_POHYB,
	ZAKAZKAND_PREDCHUDCE,
	ZAKAZKAND_SHODA,
	ZAKAZKAND_CAMPAIGN,
];

export enum JFND_ZPRACOVAVANY_ZAZNAM {
	NOTSET,
	SDA,
	SNND,
	BLOKACE,
	REZERVACE,
	EANTERM,
	ETKA,
}

export enum ND_AKCE_PC {
	PONECHAT_PC,
	NAHRADIT_PC,
	PREPOCET_PC,
}

export enum MIO_PZN {
	RYO = 1,
	SKO = 2,
}

export enum SPLIT_PARTY {
	INSURANCE = 2,
	CUSTOMER = 1,
	GOODWILL = 3
}

export enum LINE_ITEM_STATUS_REASON {
	PENDING_REASON = 4,
	CANCELLATION_REASON = 5,
}
export type DependentTableNames = typeof DEPENDENT_TABLES_ALL[number];
export const zakazkaDruhySet = new Set([
	ZAKAZKA_DRUH.GARANCE,
	ZAKAZKA_DRUH.PREVOD_ND,
	ZAKAZKA_DRUH.ZPETNY_ODKUP_ND,
]);

export const SERVICE_JOB_ID = 'SERVICE_JOB_ID';
export const DISCOUNT_PERCENT = 'DISCOUNT_PERCENT';
export const LINE_ITEM_STATUS_ID = 'LINE_ITEM_STATUS_ID';
export const PENDING_REASON_ID = 'PENDING_REASON_ID';
export const PENDING_REMARKS_OTHERS = 'PENDING_REMARKS_OTHERS';
export const BILL_TO = 'BILL_TO';
export const PC_JDN_ZKR = 'PC_JDN_ZKR';
export const IS_ADDITIONAL = 'IS_ADDITIONAL';
export const PC_WITHOUT_GST = 'PC_WITHOUT_GST';
export const PC_WITH_GST = 'PC_WITH_GST';
export const PC_VC_DPH_NAD = 'PC_VC_DPH_NAD';
export const PC_BEZ_DPH_NAD = 'PC_BEZ_DPH_NAD';
export const PC_SLEVA_PO  = 'PC_SLEVA_PO';
export const PC_CEL_SL_PRED = 'PC_CEL_SL_PRED';
export const TEXT = 'TEXT';
export const NOTE = 'NOTE';
export const MIN_FIELD_LEVEL = 0;
export const MIN_DISCOUNT_LIMIT = 0;
export const MAX_DISCOUNT_LIMIT = 100;
export const RRP_UNIT_PRICE = 'RRP_UNIT_PRICE';
export const TECHNICIAN = 'TECHNICIAN';
export const ND_NR = 'ND_NR';
export const WARRANTY_PRICE = 'WARRANTY_PRICE';
export const IS_PARTY_LEVEL_DISCOUNT_ENABLE = 'IS_PARTY_LEVEL_DISCOUNT_ENABLE';
export const DISCOUNT_VAL = 'DISCOUNT_VAL';

export const PART_COLS = {
	SERVICE_JOB_ID,
	DISCOUNT_PERCENT,
	IS_ADDITIONAL,
	LINE_ITEM_STATUS_ID,
	PENDING_REASON_ID,
	PENDING_REMARKS_OTHERS,
	BILL_TO,
	PC_JDN_ZKR,
	PC_WITHOUT_GST,
	PC_WITH_GST,
	PC_VC_DPH_NAD,
	PC_BEZ_DPH_NAD,
	PC_SLEVA_PO,
	PC_CEL_SL_PRED,
	TEXT,
	NOTE,
	RRP_UNIT_PRICE,
	TECHNICIAN,
	ND_NR,
	WARRANTY_PRICE,
	IS_PARTY_LEVEL_DISCOUNT_ENABLE,
	DISCOUNT_VAL
};
